import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _noop from 'lodash/noop';
import List from '../list';
import { videoCardTypes } from '../video-card';
import {
    getPaginatedList,
    breakPointsName,
} from '../utils/pagination-utils';
import useWindowDimensions from '../hooks/use-window-dimensions';

const LandingPage = ({
    listItems,
    title,
    itemsPerBreakpoint,
    topicSlug,
    onItemClick,
    itemsBasePath,
    lang,
}) => {

    const [
        clickedTimes,
        updateClickedTimes,
    ] = useState(1);

    const {
        ITEMS_PER_SMALL_BP,
        ITEMS_PER_MEDIUM_BP,
        ITEMS_PER_LARGE_BP,
        ITEMS_PER_XL_BP,
    } = itemsPerBreakpoint;

    const breakpointData = {
        [breakPointsName.small]: ITEMS_PER_SMALL_BP,
        [breakPointsName.medium]: ITEMS_PER_MEDIUM_BP,
        [breakPointsName.large]: ITEMS_PER_LARGE_BP,
        [breakPointsName.xl]: ITEMS_PER_XL_BP,
    };

    const { width: currentWidth } = useWindowDimensions();
    const {
        paginatedList,
        moreItemsToPaginate,
    } = getPaginatedList(listItems, clickedTimes, breakpointData, currentWidth);

    useEffect(() => {

        updateClickedTimes(1);

    }, [topicSlug]);

    return (
        <section className="landing-page">
            <h1 className="landing-page__title">{title}</h1>
            <List
                listItems={paginatedList}
                className="landing-page__list"
                buttonClickHandler={() => updateClickedTimes(clickedTimes + 1)}
                hideButton={!moreItemsToPaginate}
                onItemClick={onItemClick}
                videoCardType={videoCardTypes.PORTRAIT}
                itemsBasePath={itemsBasePath}
                topicSlug={topicSlug}
                lang={lang}
            />
        </section>
    );

};

LandingPage.defaultProps = {
    title: '',
    listItems: [],
    itemsPerBreakpoint: {
        ITEMS_PER_SMALL_BP: 6,
        ITEMS_PER_MEDIUM_BP: 15,
        ITEMS_PER_LARGE_BP: 16,
        ITEMS_PER_XL_BP: 20,
    },
    topicSlug: '',
    onItemClick: _noop,
    lang: 'en',
};

LandingPage.propTypes = {
    title: PropTypes.string,
    listItems: PropTypes.array,
    itemsPerBreakpoint: PropTypes.object,
    topicSlug: PropTypes.string,
    itemsBasePath: PropTypes.string.isRequired,
    onItemClick: PropTypes.func,
};

export default LandingPage;
